import { useCallback } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { isNullOrUndefined } from "../utils/generalFunctions";
import { largeObjectsDB } from "../store/largeObjectsDB";



/**
 * Hook to get a live, reactive value from IndexedDB.
 * Updates automatically when the DB changes.
 */
export function RefLargeObjectValue(key) {
    const value = useLiveQuery(
        async () => {
            const storedValue = await largeObjectsDB.getValue(key);
            return isNullOrUndefined(storedValue) ? null : storedValue;
        },
        [key],
        null // default value while loading
    );

    return value;
}

/**
 * Hook to get and set a value in IndexedDB reactively.
 * If setValue(null) is called, the key will be removed from DB.
 */
export function StateLargeObjectValue(key) {
    const value = RefLargeObjectValue(key);

    const setValue = useCallback(
        async (newValue) => {
            if (isNullOrUndefined(newValue)) {
                await largeObjectsDB.removeValue(key);
            } else {
                await largeObjectsDB.setValue(key, newValue);
            }
        },
        [key]
    );

    return [value, setValue];
}
